import { render, staticRenderFns } from "./_LinkSetting.vue?vue&type=template&id=1f448acc&"
import script from "./_LinkSetting.vue?vue&type=script&lang=js&"
export * from "./_LinkSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports